import React from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';

interface PreloaderProps {
    message?: string;
}

const Preloader: React.FC<PreloaderProps> = ({ message }) => (
    <Box
        sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column', // Changed to column for better vertical centering
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.9)', // Slight transparency
            zIndex: 9999, // Ensures it stays on top
        }}
    >
        <CircularProgress color="primary" size={60} thickness={4} />

        {message !== '' && (
            <Typography
                sx={{
                    marginTop: 3,
                    fontWeight: 500,
                    color: 'text.secondary',
                    // Responsive font sizing based on your size prop
                    fontSize: '1.5rem',
                }}
            >
                {message || 'Loading...'}
            </Typography>
        )}
    </Box>
);

export default Preloader;
